import React, { Component } from 'react';



class travelNoteToronto extends Component {

    render() {

        return ( 
            <section>
        <header>


<nav className="nav-wrapper black">
<div className="container">
    <a href="/" className="brand-logo ">
        <span>Y.X.</span>
    </a>
    
    <a href="" className="sidenav-trigger" data-target="mobile-menu">
    <i className="material-icons">menu</i>
    </a>
    <ul className="right hide-on-med-and-down">
    <li><a href="/travel">Travel</a></li>
    <li><a href="/music">Music</a></li>
    <li><a href="/calligraphy">Calligraphy</a></li>
    
    <li><a href="/cat">🐈</a></li>

    <li><a href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
    </a></li>
    <li><a href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-youtube"></i>
    </a></li>
    <li><a href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook"></i>
    </a></li>
    <li><a href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter"></i>
    </a></li>
    <li><a href="/travelNoteTorontoCN" className="btn btn-floating transparent">CN</a></li>
    
    </ul>
    
    <ul className="sidenav grey lighten-2" id="mobile-menu">
        <li><a href="/travel" className="sidenavtext">Travel</a></li>
        <li><a href="/music" className="sidenavtext">Music</a></li>
        <li><a href="/calligraphy" className="sidenavtext">Calligraphy</a></li>
        <li><a href="/cat" className="sidenavtext">My Cat</a></li>
        <li><a href="/#aboutmenav" className="sidenavtext">About Me</a></li>
            <br/>
            <li><a href="/travelNoteTorontoCN" className="sidenavtext">CN</a></li>

    </ul>
</div>
</nav>
</header>

            
            <div className="row hide-on-small-only" id="travelNoteToronto">
                <div className="col s2 m2 l2">
                    <div>
                        {/* <nav className="nav">
                            <a href="#video4">title 4</a>
                        </nav> */}
                        
                        <ul className="nav">
                        <div className="bigTitle">Toronto</div>
                            {/* <li className="titleDate">
                                <a href="#title0">2018/09/02</a>
                            </li>
                            <li className="smallTitle">
                                <a>0.1/ </a>
                                <a href="#title0">抵达</a>
                            </li> */}
                            <li className="titleDate">
                                <a href="#title1">Spring</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.1/ </a>
                                <a href="#title1">CN Tower</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.2/ </a>
                                <a href="#title2">Royal Ontario Museum</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.3/ </a>
                                <a href="#title3">High Park</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.4/ </a>
                                <a href="#title4">Centre Island</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.5/ </a>
                                <a href="#title5">Air Canada Centre</a>
                            </li>

                            <li className="titleDate">
                                <a href="#title6">Summer</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.1/ </a>
                                <a href="#title6">Canada's Wonderland</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.2/ </a>
                                <a href="#title7">Woodbine Beach</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.3/ </a>
                                <a href="#title8">Toronto Zoo</a>
                            </li>
                            
                            <li className="titleDate">
                                <a href="#title9">Autumn</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.1/ </a>
                                <a href="#title9">Thousand Islands</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.2/ </a>
                                <a href="#title10">Lake Muskoka</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.3/ </a>
                                <a href="#title11">Niagara Falls</a>
                            </li>
                            
                            <li className="titleDate">
                                <a href="#title12">Winter</a>
                            </li>
                            <li className="smallTitle">
                                <a>4.1/ </a>
                                <a href="#title12">Art Gallery of Ontario</a>
                            </li>
                            <li className="smallTitle">
                                <a>4.2/ </a>
                                <a href="#title13">City Hall</a>
                            </li>


                        </ul>
                    </div>
                </div>

                <div className="col s9 m9 l9 offset-s1 offset-m1 offset-l1 noteToronto">
                    {/* <div className="video" id="video1">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video2">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video3">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video4">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video5">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video6">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div> */}

                        <div className="row">
                            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
                            <div className="row travelDetail">
                                <div className="time col s12 m4 l4">
                                    <i className=" material-icons left">access_time</i>
                                    <span>Departure</span>
                                    <span> / </span>
                                    <span>2014-08-27</span>
                                </div>
                                <div className="day col s12 m4 l4">
                                    <i className=" material-icons left">wb_sunny</i>
                                    <span>Travel Days</span>
                                    <span> / </span>
                                    <span>---</span>
                                </div>
                                <div className="people col s12 m4 l4">
                                    <i className=" material-icons left">account_circle</i>
                                    <span>People</span>
                                    <span> / </span>
                                    <span>---</span>
                                </div>
                            </div>
                            <div className="col s1 m1 l1"></div>
                            </div>
                        </div>

                    <div className="titles" id="title1">
                        <h4 className="title">CN Tower</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/1.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/CN+Tower/@43.6425701,-79.3892455,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34d68bf33a9b:0x15edd8c4de1c7581!8m2!3d43.6425662!4d-79.3870568">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">CN Tower</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal1">Introduction</a>
                        <div id="modal1" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">CN Tower - Introduction</h4>
                            <p>The CN Tower (French: Tour CN) is a 553.3 m-high (1,815.3 ft) concrete communications and observation tower located in Downtown Toronto, Ontario, Canada. Built on the former Railway Lands, it was completed in 1976. Its name "CN" originally referred to Canadian National, the railway company that built the tower. Following the railway's decision to divest non-core freight railway assets prior to the company's privatization in 1995, it transferred the tower to the Canada Lands Company, a federal Crown corporation responsible for real estate development.</p>
                            <p className="grey-text">加拿大国家电视塔（法语：Tour CN）是高553.3 m（1,815.3 ft）的混凝土通讯和观测塔，位于加拿大安大略省多伦多市中心。 它建于前铁路土地上，于1976年完工。其名称“ CN”最初指建造塔的铁路公司加拿大国家铁路公司（Canadian National）。 在1995年铁路公司决定私有化之前，该铁路公司决定剥离非核心货运铁路资产之后，它将铁塔移交给了负责房地产开发的联邦皇冠公司Canada Lands Company。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/CN_Tower">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title2">
                        <h4 className="title" >Royal Ontario Museum</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/2.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Royal+Ontario+Museum/@43.6677136,-79.3969658,17z/data=!3m2!4b1!5s0x882b34bb1cf03ad7:0xfc55bd23d1c14ab3!4m5!3m4!1s0x882b34baf3dae513:0xc98434e11ec5f592!8m2!3d43.6677097!4d-79.3947771">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Royal Ontario Museum</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal2">Introduction</a>
                        <div id="modal2" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Royal Ontario Museum - Introduction</h4>
                            <p>The Royal Ontario Museum is a museum of art, world culture and natural history in Toronto, Ontario, Canada. It is one of the largest museums in North America and the largest in Canada. It attracts more than one million visitors every year, making the ROM the most-visited museum in Canada. The museum is north of Queen's Park, in the University of Toronto district, with its main entrance on Bloor Street West. Museum subway station is named after the ROM and, since a 2008 renovation, is decorated to resemble the institution's collection.</p>
                            <p className="grey-text">皇家安大略博物馆是位于加拿大安大略省多伦多的艺术，世界文化和自然历史博物馆。 它是北美最大的博物馆之一，也是加拿大最大的博物馆。 每年吸引超过100万游客，使ROM成为加拿大参观人数最多的博物馆。 该博物馆位于多伦多大学区皇后公园以北，其主要入口位于Bloor Street West。 博物馆地铁站以ROM的名字命名，自2008年进行翻新以来，其装饰风格与博物馆的馆藏相似。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Royal_Ontario_Museum">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title3">
                        <h4 className="title">High Park</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/3.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/High+Park/@43.6465518,-79.465879,17z/data=!3m1!4b1!4m5!3m4!1s0x882b35d32336f705:0x1bcc825a300ee67!8m2!3d43.6465479!4d-79.4636903">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">High Park</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal3">Introduction</a>
                        <div id="modal3" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">High Park - Introduction</h4>
                            <p>High Park is a municipal park in Toronto, Ontario, Canada. High Park is a mixed recreational and natural park, with sporting facilities, cultural facilities, educational facilities, gardens, playgrounds and a zoo. One-third of the park remains in a natural state, with a rare oak savannah ecology. High Park was opened to the public in 1876 and is based on a bequest of land from John George Howard to the City of Toronto. It spans 161 hectares (400 acres) and is the second-largest municipal park in Toronto, after Centennial Park.</p>
                            <p className="grey-text">海柏公园是加拿大安大略省多伦多市的市政公园。 高地公园是一个休闲娱乐和自然公园，设有体育设施，文化设施，教育设施，花园，游乐场和动物园。 公园的三分之一仍处于自然状态，并具有罕见的橡木大草原生态。 高地公园于1876年向公众开放，其基础是从约翰·乔治·霍华德到多伦多市的土地遗赠。 它占地161公顷（400英亩），是仅次于百年纪念公园的多伦多第二大市政公园。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/High_Park">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title4">
                        <h4 className="title">Centre Island</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/4.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Centre+Island,+Toronto,+ON/@43.6230069,-79.3946795,14z/data=!3m1!4b1!4m5!3m4!1s0x89d4cacba94d0d87:0xd4d9ff7257f012f8!8m2!3d43.6185339!4d-79.373833">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Centre Island</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal4">Introduction</a>
                        <div id="modal4" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Centre Island - Introduction</h4>
                            <p>Centre island is the middle of the three primary Toronto Island destinations. It's sandwiched between Ward's Island on the east and Hanlan's Point on the west.</p>
                            <p className="grey-text">中心岛是多伦多三个主要目的地的中间地带。 它夹在东部的沃德岛和西部的汉兰角之间。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://www.torontoisland.com/center.php">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title5">
                        <h4 className="title">Air Canada Centre</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/5.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Scotiabank+Arena/@43.6424141,-79.3778114,17z/data=!3m1!5s0x89d4cb2b5d4aaf65:0xcf3aa22b5f6baba4!4m5!3m4!1s0x89d4cb2b5935bf09:0x5842d0e7d5669410!8m2!3d43.6434661!4d-79.3790989">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Air Canada Centre</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal5">Introduction</a>
                        <div id="modal5" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Air Canada Centre - Introduction</h4>
                            <p>Scotiabank Arena, formerly Air Canada Centre, is a multi-purpose arena located on Bay Street in the South Core district of Downtown Toronto, Ontario, Canada. It is the home of the Toronto Raptors of the National Basketball Association (NBA), the Toronto Maple Leafs of the National Hockey League (NHL), and the Toronto Rock of the National Lacrosse League (NLL). In addition, the minor league Toronto Marlies of the American Hockey League (AHL) and the Raptors 905 of the NBA G League play occasional games at the arena. The arena was previously home to the Toronto Phantoms of the Arena Football League (AFL) during their brief existence.</p>
                            <p className="grey-text">丰业银行竞技场，以前是加拿大航空中心，是一个多功能的竞技场，位于加拿大安大略省多伦多市中心南核心区的海湾大街上。 它是国家篮球协会（NBA）的多伦多猛龙队，国家曲棍球联盟（NHL）的多伦多枫叶队和国家长曲棍球联盟（NLL）的多伦多巨石的故乡。 此外，美国曲棍球联盟（AHL）的未成年人联盟多伦多马里队和NBA G联赛的猛龙905在竞技场上偶尔玩些比赛。 竞技场曾短暂存在过，曾经是竞技场橄榄球联盟（AFL）多伦多幻影的故乡。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Scotiabank_Arena">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title6">
                        <h4 className="title">Canada's Wonderland</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/6.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Canada's+Wonderland/@43.8430214,-79.5416512,17z/data=!3m1!4b1!4m5!3m4!1s0x882b2f4b21b97b7b:0x87a6830532b2fcfc!8m2!3d43.8430176!4d-79.5394625">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Canada's Wonderland</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal6">Introduction</a>
                        <div id="modal6" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Canada's Wonderland - Introduction</h4>
                            <p>Canada's Wonderland is a 134-hectare (330-acre) theme park located in Vaughan, Ontario, a suburb approximately 25 kilometres (16 mi) north of Downtown Toronto. Opened in 1981 by the Taft Broadcasting Company and The Great-West Life Assurance Company as the first major theme park in Canada, it remains the country's largest. The park, currently owned by Cedar Fair, has been the most visited seasonal amusement park in North America for several consecutive years.</p>
                            <p className="grey-text">加拿大的仙境公园是一个134公顷（330英亩）的主题公园，位于安大略省沃恩市，该郊区位于多伦多市中心以北约25公里（16英里）。 塔夫脱广播公司和Great-West人寿保险公司于1981年开业，是加拿大第一个大型主题公园，至今仍是加拿大最大的主题公园。 该公园目前由Cedar Fair拥有，已连续数年成为北美访问量最大的季节性游乐园。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Canada's_Wonderland">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title7">
                        <h4 className="title">Woodbine Beach</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/7.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Woodbine+Beach/@43.662238,-79.311029,17z/data=!4m8!1m2!2m1!1sWoodbine+Beach!3m4!1s0x89d4cbf1b403037f:0x7e1c4a7ac9e90b29!8m2!3d43.662238!4d-79.3088403">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Woodbine Beach</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal7">Introduction</a>
                        <div id="modal7" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Woodbine Beach - Introduction</h4>
                            <p> Woodbine Beach is the largest of the four beaches in the Beaches in Toronto, Ontario, Canada. Located along Lake Shore Boulevard at the foot of Woodbine Avenue, it is next to Ashbridge's Bay and Kew-Balmy Beach. Woodbine beach is the westernmost beach in the Beaches, and the series of beaches extend east until the RC Harris Water Treatment Plant. The beach runs parallel to the boardwalk and the Martin Goodman Trail, and is part of Woodbine Beach Park.</p>
                            <p className="grey-text">Woodbine海滩是加拿大安大略省多伦多海滩中四个海滩中最大的海滩。 它位于伍德拜恩大道（Woodbine Avenue）脚下的湖岸大道（Lake Shore Boulevard）旁，毗邻阿什布里奇湾（Ashbridge's Bay）和基尤-巴尔米（Kew-Balmy Beach）海滩。 伍德拜恩海滩是海滩中最西端的海滩，一系列海滩向东延伸，直到RC哈里斯水处理厂。 海滩与木板路和马丁·古德曼步道（Martin Goodman Trail）平行，是伍德拜恩海滩公园的一部分。
                           </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Woodbine_Beach">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title8">
                        <h4 className="title" >Toronto Zoo</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/8.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Toronto+Zoo/@43.8177028,-79.1880791,17z/data=!3m1!4b1!4m5!3m4!1s0x89d4d9f1ad96dacd:0x9e197a60028bb5d8!8m2!3d43.817699!4d-79.1858904">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Toronto Zoo</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal8">Introduction</a>
                        <div id="modal8" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Toronto Zoo - Introduction</h4>
                            <p>The Toronto Zoo is a zoo located in Toronto, Ontario, Canada. Encompassing 287 hectares (710 acres), the Toronto Zoo is the largest zoo in Canada. It is divided into seven zoogeographic regions: Indo-Malaya, Africa, Americas, Tundra Trek, Australasia, Eurasia, and the Canadian Domain. Some animals are displayed indoors in pavilions and outdoors in what would be their naturalistic environments, with viewing at many levels. It also has areas such as the Kids Zoo, Waterside Theatre, and Splash Island. It has one of the most taxonomically diverse collection of animals on display of any zoo; it is currently home to over 5,000 animals (including invertebrates and fish) representing over 500 species. The zoo is open to the public every day of the year except December 25.</p>
                            <p className="grey-text">多伦多动物园是位于加拿大安大略省多伦多的动物园。 多伦多动物园占地287公顷（710英亩），是加拿大最大的动物园。 它分为七个动物地理区域：印度马来亚，非洲，美洲，苔原跋涉，大洋洲，欧亚大陆和加拿大领地。 一些动物在自然环境中被展示在室内的凉亭中和室外，并在许多层面上进行观察。 它还有儿童动物园，水边剧院和飞溅岛等地区。 它是任何动物园展出的动物分类学最丰富的动物之一。 目前，这里有超过5,000种动物（包括无脊椎动物和鱼类），它们代表500多种物种。 除12月25日外，该动物园每天都对公众开放。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Toronto_Zoo">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title9">
                        <h4 className="title">Thousand Islands</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/9.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Thousand+Islands/@44.298924,-76.4270832,10z/data=!3m1!4b1!4m5!3m4!1s0x4ccd4ef10e8e0e1b:0x125cfc305bcff037!8m2!3d44.2987749!4d-76.1468963">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Thousand Islands</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal9">Introduction</a>
                        <div id="modal9" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Thousand Islands - Introduction</h4>
                            <p> The Thousand Islands are a group of more than 1,800 islands in the St. Lawrence River, straddling the border of the U.S. and Canada. A fashionable retreat for the elite in the late 19th century, today the area is a hub for outdoor activities. It’s home to elaborate island mansions such as the German-style Boldt Castle on Heart Island, and Singer Castle on Dark Island, with its Gothic windows and secret passageways.</p>
                            <p className="grey-text">千岛群岛位于圣劳伦斯河上，共有1,800多个岛屿，横跨美国和加拿大的边界。 19世纪后期，这是精英人士的时尚度假胜地，如今，该地区已成为户外活动的枢纽。 这里是精心打造的岛屿豪宅的所在地，例如，心岛上的德国式Boldt城堡和黑岛上的辛格城堡，带有哥特式窗户和秘密通道。
                           </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://www.google.com/travel/things-to-do?g2lb=2502548%2C4258168%2C4270442%2C4271060%2C4306835%2C4317915%2C4328159%2C4371335%2C4401769%2C4419364%2C4428792%2C4429191%2C4431296%2C4433754%2C4447566%2C4456077%2C4458304%2C4462650%2C4463263%2C4270859%2C4284970%2C4291517%2C4412690&hl=en-CA&gl=ca&un=1&dest_mid=%2Fm%2F0179bc&dest_state_type=main&dest_src=kl&sa=X&ved=2ahUKEwjL0Y7FqIPtAhVXbs0KHdiaCzoQri4wKXoECCEQAw#ttdm=44.878451_-76.003458_8&ttdmf=%252Fm%252F07l8q8">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        <div className="titleContent">
                            <h5>2018/09/16</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img20/1.png" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Take a boat from Thousand Islands to Castle.</p>
                                    <p>To get to the island, you need to go through US customs first.</p>
                                    <p>The return must go through Canadian customs. (When disembarking, the staff just glanced at the passport)</p>
                                </div>
                            </div>

                        </div>
                        
                    </div>

                    <div className="titles" id="title10">
                        <h4 className="title">Lake Muskoka</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/10.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Lake+Muskoka/@45.015276,-79.606799,11z/data=!3m1!4b1!4m5!3m4!1s0x4d2a8be67bed8b2b:0xa3ff336db476576a!8m2!3d45.0318626!4d-79.4475238">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Lake Muskoka</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        {/* <a className="btn-flat modal-trigger right info " href="#modal10">Introduction</a>
                        <div id="modal10" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">赏枫 - Introduction</h4>
                            <p>奥林匹克体育场是位于加拿大蒙特利尔的多功能体育场，位于城市Hochelaga-Maisonneuve区的奥林匹克公园。它建于1970年代中期，是1976年夏季奥林匹克运动会的主要场馆，因此被昵称为“大O”，既指其名称，又指体育场屋顶永久部件的甜甜圈形状。紧邻体育场的塔楼，蒙特利尔塔，是世界上最高的倾斜塔，仰角为45度。它也被称为“ Big Owe”，是指体育场和整个1976年奥运会的天文成本。
<br/>
<br/>
该体育场是加拿大座位最多的体育场。奥运会之后，安装了人造草皮，它成为蒙特利尔专业棒球队和橄榄球队的所在地。 1998年，CFL的蒙特利尔长者队回到了他们以前的莫尔森体育馆进行常规赛，但是直到2014年他们回到莫尔森体育馆进行所有比赛后，他们都继续使用奥林匹克体育场进行季后赛和灰色杯比赛。</p>
                            <p className="grey-text">Olympic Stadium is a multi-purpose stadium in Montreal, Canada, located at Olympic Park in the Hochelaga-Maisonneuve district of the city. Built in the mid-1970s as the main venue for the 1976 Summer Olympics, it is nicknamed "The Big O", a reference to both its name and to the doughnut-shape of the permanent component of the stadium's roof. The tower standing next to the stadium, The Montreal Tower, is the tallest inclined tower in the world with an angle elevation of 45 degrees. It is also called "The Big Owe" to reference the astronomical cost of the stadium and the 1976 Olympics as a whole.
                            <br/>
<br/>
The stadium is the largest by seating capacity in Canada. After the Olympics, artificial turf was installed and it became the home of Montreal's professional baseball and football teams. The Montreal Alouettes of the CFL returned to their previous home of Molson Stadium in 1998 for regular season games, but continued to use Olympic Stadium for playoff and Grey Cup games until 2014 when they returned to Molson Stadium for all of their games. </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Olympic_Stadium_(Montreal)">
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div> */}

                        </div>
                            </div>
                        </div>

                  
                        
                        
                    </div>

                    <div className="titles" id="title11">
                        <h4 className="title">Niagara Falls</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/11.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Niagara+Falls,+ON/@43.054098,-79.2281194,11z/data=!3m1!4b1!4m5!3m4!1s0x89d3445eec824db9:0x46d2c56156bda288!8m2!3d43.0895577!4d-79.0849436">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Niagara Falls</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal11">Introduction</a>
                        <div id="modal11" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Niagara Falls - Introduction</h4>
                            <p>Niagara Falls is a group of three waterfalls at the southern end of Niagara Gorge, spanning the border between the province of Ontario in Canada and the state of New York in the United States. The largest of the three is Horseshoe Falls, also known as Canadian Falls, which straddles the international border of the two countries. The smaller American Falls and Bridal Veil Falls lie within the United States. Bridal Veil Falls are separated from Horseshoe Falls by Goat Island and from American Falls by Luna Island, with both islands situated in New York.</p>
                            <p className="grey-text">尼亚加拉大瀑布是由三个瀑布组成的一组，位于尼亚加拉峡谷的南端，横跨加拿大安大略省和美国纽约州之间的边界。 这三个国家中最大的一个是马蹄瀑布，又称加拿大瀑布，横跨两国的国际边界。 较小的美国瀑布和新娘面纱瀑布位于美国境内。 新娘面纱瀑布与山羊岛的马蹄瀑布和月神岛的美国瀑布分开，两个岛都位于纽约。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Niagara_Falls">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title12">
                        <h4 className="title">Art Gallery of Ontario</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/12.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Art+Gallery+of+Ontario/@43.6536105,-79.394701,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34c5ed5319bd:0xda277755ede046af!8m2!3d43.6536066!4d-79.3925123">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Art Gallery of Ontario</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal12">Introduction</a>
                        <div id="modal12" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Art Gallery of Ontario - Introduction</h4>
                            <p>The Art Gallery of Ontario is an art museum in Toronto, Ontario, Canada. The museum is located in the Grange Park neighbourhood of downtown Toronto, on Dundas Street West between McCaul and Beverley streets. The museum's building complex takes up 45,000 square metres (480,000 sq ft) of physical space, making it one of the largest art museums in North America. In addition to exhibition spaces, the museum also houses an artist-in-residence office and studio, dining facilities, event spaces, gift shop, library and archives, theatre and lecture hall, research centre, and a workshop.</p>
                            <p className="grey-text">安大略美术馆是加拿大安大略省多伦多市的一家美术馆。 该博物馆位于多伦多市中心的格兰奇公园（Grange Park）附近，在麦考尔（McCaul）和贝弗利（Beverley）街道之间的邓达斯西街（Dundas Street West）上。 博物馆的建筑群占地45,000平方米（480,000平方英尺），是北美最大的艺术博物馆之一。 除了展览空间外，博物馆还设有驻场艺术家办公室和工作室，餐饮设施，活动空间，礼品店，图书馆和档案馆，剧院和演讲厅，研究中心以及车间。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Art_Gallery_of_Ontario">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title13">
                        <h4 className="title">City Hall</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img19/13.png" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Toronto+City+Hall/@43.6534438,-79.3862788,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34cc66e75af3:0x31c21a86913322e0!8m2!3d43.6534399!4d-79.3840901">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">City Hall</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal13">Introduction</a>
                        <div id="modal13" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">City Hall - Introduction</h4>
                            <p>The Toronto City Hall, or New City Hall, is the seat of the municipal government of Toronto, Ontario, Canada, and one of the city's most distinctive landmarks. Designed by Finnish architect Viljo Revell (with Heikki Castrén, Bengt Lundsten, and Seppo Valjus) and landscape architect Richard Strong, and engineered by Hannskarl Bandel, the building opened in 1965. It was built to replace Old City Hall, which had housed city offices since 1899. The current city hall, located at Nathan Phillips Square, is the city's fourth and was built to replace its predecessor which the city outgrew shortly after its completion.</p>
                            <p className="grey-text">多伦多市政厅或新市政厅是加拿大安大略省多伦多市政府所在地，也是该市最独特的地标之一。 该建筑由芬兰建筑师Viljo Revell（与HeikkiCastrén，Bengt Lundsten和Seppo Valjus共同设计）和景观设计师Richard Strong设计，并由Hannskarl Bandel设计，于1965年开放。它的建成是为了取代旧市政厅，该市政厅设有市政厅。 自1899年以来。当前的市政厅位于内森·菲利普斯广场（Nathan Phillips Square），是该市的第四座市政厅，其建成是为了取代其前身，后者在建成后不久就消失了。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Toronto_City_Hall">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>



                    <h4 className="title"> </h4>

                    {/* <div className="Comment">
                    
                        <div className="row">   
                        <div className="col s1 m1 l1">
                            <a className="btn btn-floating black lighten-1 ">YX</a>
                        </div>
                        <div className="col s11 m11 l11 commentContent">
                            <form action="">
                                <div className="input-field">
                                    <textarea id="message" className="materialize-textarea"></textarea>
                                    <label htmlFor="message">发表评论</label>
                                </div>
                            </form>
                        </div>
                        </div>

                      

                    </div> */}
                    


                </div>
            </div>

            <div className="row hide-on-med-and-up" id="travelNoteToronto">

<div className="col s12 m12 l12 noteToronto">
   
<a href="" className="sidenav-trigger" data-target="mobile-menu999">
        <i className="material-icons smallnotenav" >menu</i>
    </a>
    <ul className="sidenav grey lighten-2 sidenav999" id="mobile-menu999">
    <div className="bigTitle">Toronto</div>
            {/* <li className="titleDate">
                <a href="#title0">2018/09/02</a>
            </li>
            <li className="smallTitle">
                <a>0.1/ </a>
                <a href="#title0">抵达</a>
            </li> */}
            <li className="titleDate">
                <a href="#title14">Spring</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title14">CN Tower</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title15">Royal Ontario Museum</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title16">High Park</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title17">Centre Island</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title18">Air Canada Centre</a>
            </li>

            <li className="titleDate">
                <a href="#title19">Summer</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title19">Canada's Wonderland</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title20">Woodbine Beach</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title21">Toronto Zoo</a>
            </li>
            
            <li className="titleDate">
                <a href="#title22">Autumn</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title22">Thousand Islands</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title23">Lake Muskoka</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title24">Niagara Falls</a>
            </li>
            
            <li className="titleDate">
                <a href="#title25">Winter</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title25">Art Gallery of Ontario</a>
            </li>
            <li className="smallTitle">
            
                <a href="#title26">City Hall</a>
            </li>
        
    </ul>


        <div className="row">
            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
            <div className="row travelDetail">
                <div className="time col s12 m4 l4">
                    <i className=" material-icons left">access_time</i>
                    <span>Departure</span>
                    <span> / </span>
                    <span>2014-08-27</span>
                </div>
                <div className="day col s12 m4 l4">
                    <i className=" material-icons left">wb_sunny</i>
                    <span>Travel Days</span>
                    <span> / </span>
                    <span>---</span>
                </div>
                <div className="people col s12 m4 l4">
                    <i className=" material-icons left">account_circle</i>
                    <span>People</span>
                    <span> / </span>
                    <span>---</span>
                </div>
            </div>
            <div className="col s1 m1 l1"></div>
            </div>
        </div>

        <div className="titles" id="title14">
<h4 className="title">CN Tower</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/1.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/CN+Tower/@43.6425701,-79.3892455,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34d68bf33a9b:0x15edd8c4de1c7581!8m2!3d43.6425662!4d-79.3870568">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">CN Tower</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9991">Introduction</a>
<div id="modal9991" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">CN Tower - Introduction</h4>
    <p>The CN Tower (French: Tour CN) is a 553.3 m-high (1,815.3 ft) concrete communications and observation tower located in Downtown Toronto, Ontario, Canada. Built on the former Railway Lands, it was completed in 1976. Its name "CN" originally referred to Canadian National, the railway company that built the tower. Following the railway's decision to divest non-core freight railway assets prior to the company's privatization in 1995, it transferred the tower to the Canada Lands Company, a federal Crown corporation responsible for real estate development.</p>
    <p className="grey-text">加拿大国家电视塔（法语：Tour CN）是高553.3 m（1,815.3 ft）的混凝土通讯和观测塔，位于加拿大安大略省多伦多市中心。 它建于前铁路土地上，于1976年完工。其名称“ CN”最初指建造塔的铁路公司加拿大国家铁路公司（Canadian National）。 在1995年铁路公司决定私有化之前，该铁路公司决定剥离非核心货运铁路资产之后，它将铁塔移交给了负责房地产开发的联邦皇冠公司Canada Lands Company。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/CN_Tower">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title15">
<h4 className="title" >Royal Ontario Museum</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/2.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Royal+Ontario+Museum/@43.6677136,-79.3969658,17z/data=!3m2!4b1!5s0x882b34bb1cf03ad7:0xfc55bd23d1c14ab3!4m5!3m4!1s0x882b34baf3dae513:0xc98434e11ec5f592!8m2!3d43.6677097!4d-79.3947771">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Royal Ontario Museum</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9992">Introduction</a>
<div id="modal9992" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Royal Ontario Museum - Introduction</h4>
    <p>The Royal Ontario Museum is a museum of art, world culture and natural history in Toronto, Ontario, Canada. It is one of the largest museums in North America and the largest in Canada. It attracts more than one million visitors every year, making the ROM the most-visited museum in Canada. The museum is north of Queen's Park, in the University of Toronto district, with its main entrance on Bloor Street West. Museum subway station is named after the ROM and, since a 2008 renovation, is decorated to resemble the institution's collection.</p>
    <p className="grey-text">皇家安大略博物馆是位于加拿大安大略省多伦多的艺术，世界文化和自然历史博物馆。 它是北美最大的博物馆之一，也是加拿大最大的博物馆。 每年吸引超过100万游客，使ROM成为加拿大参观人数最多的博物馆。 该博物馆位于多伦多大学区皇后公园以北，其主要入口位于Bloor Street West。 博物馆地铁站以ROM的名字命名，自2008年进行翻新以来，其装饰风格与博物馆的馆藏相似。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Royal_Ontario_Museum">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title16">
<h4 className="title">High Park</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/3.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/High+Park/@43.6465518,-79.465879,17z/data=!3m1!4b1!4m5!3m4!1s0x882b35d32336f705:0x1bcc825a300ee67!8m2!3d43.6465479!4d-79.4636903">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">High Park</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9993">Introduction</a>
<div id="modal9993" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">High Park - Introduction</h4>
    <p>High Park is a municipal park in Toronto, Ontario, Canada. High Park is a mixed recreational and natural park, with sporting facilities, cultural facilities, educational facilities, gardens, playgrounds and a zoo. One-third of the park remains in a natural state, with a rare oak savannah ecology. High Park was opened to the public in 1876 and is based on a bequest of land from John George Howard to the City of Toronto. It spans 161 hectares (400 acres) and is the second-largest municipal park in Toronto, after Centennial Park.</p>
    <p className="grey-text">海柏公园是加拿大安大略省多伦多市的市政公园。 高地公园是一个休闲娱乐和自然公园，设有体育设施，文化设施，教育设施，花园，游乐场和动物园。 公园的三分之一仍处于自然状态，并具有罕见的橡木大草原生态。 高地公园于1876年向公众开放，其基础是从约翰·乔治·霍华德到多伦多市的土地遗赠。 它占地161公顷（400英亩），是仅次于百年纪念公园的多伦多第二大市政公园。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/High_Park">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title17">
<h4 className="title">Centre Island</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/4.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Centre+Island,+Toronto,+ON/@43.6230069,-79.3946795,14z/data=!3m1!4b1!4m5!3m4!1s0x89d4cacba94d0d87:0xd4d9ff7257f012f8!8m2!3d43.6185339!4d-79.373833">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Centre Island</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9994">Introduction</a>
<div id="modal9994" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Centre Island - Introduction</h4>
    <p>Centre island is the middle of the three primary Toronto Island destinations. It's sandwiched between Ward's Island on the east and Hanlan's Point on the west.</p>
    <p className="grey-text">中心岛是多伦多三个主要目的地的中间地带。 它夹在东部的沃德岛和西部的汉兰角之间。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://www.torontoisland.com/center.php">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title18">
<h4 className="title">Air Canada Centre</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/5.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Scotiabank+Arena/@43.6424141,-79.3778114,17z/data=!3m1!5s0x89d4cb2b5d4aaf65:0xcf3aa22b5f6baba4!4m5!3m4!1s0x89d4cb2b5935bf09:0x5842d0e7d5669410!8m2!3d43.6434661!4d-79.3790989">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Air Canada Centre</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9995">Introduction</a>
<div id="modal9995" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Air Canada Centre - Introduction</h4>
    <p>Scotiabank Arena, formerly Air Canada Centre, is a multi-purpose arena located on Bay Street in the South Core district of Downtown Toronto, Ontario, Canada. It is the home of the Toronto Raptors of the National Basketball Association (NBA), the Toronto Maple Leafs of the National Hockey League (NHL), and the Toronto Rock of the National Lacrosse League (NLL). In addition, the minor league Toronto Marlies of the American Hockey League (AHL) and the Raptors 905 of the NBA G League play occasional games at the arena. The arena was previously home to the Toronto Phantoms of the Arena Football League (AFL) during their brief existence.</p>
    <p className="grey-text">丰业银行竞技场，以前是加拿大航空中心，是一个多功能的竞技场，位于加拿大安大略省多伦多市中心南核心区的海湾大街上。 它是国家篮球协会（NBA）的多伦多猛龙队，国家曲棍球联盟（NHL）的多伦多枫叶队和国家长曲棍球联盟（NLL）的多伦多巨石的故乡。 此外，美国曲棍球联盟（AHL）的未成年人联盟多伦多马里队和NBA G联赛的猛龙905在竞技场上偶尔玩些比赛。 竞技场曾短暂存在过，曾经是竞技场橄榄球联盟（AFL）多伦多幻影的故乡。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Scotiabank_Arena">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title19">
<h4 className="title">Canada's Wonderland</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/6.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Canada's+Wonderland/@43.8430214,-79.5416512,17z/data=!3m1!4b1!4m5!3m4!1s0x882b2f4b21b97b7b:0x87a6830532b2fcfc!8m2!3d43.8430176!4d-79.5394625">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Canada's Wonderland</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9996">Introduction</a>
<div id="modal9996" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Canada's Wonderland - Introduction</h4>
    <p>Canada's Wonderland is a 134-hectare (330-acre) theme park located in Vaughan, Ontario, a suburb approximately 25 kilometres (16 mi) north of Downtown Toronto. Opened in 1981 by the Taft Broadcasting Company and The Great-West Life Assurance Company as the first major theme park in Canada, it remains the country's largest. The park, currently owned by Cedar Fair, has been the most visited seasonal amusement park in North America for several consecutive years.</p>
    <p className="grey-text">加拿大的仙境公园是一个134公顷（330英亩）的主题公园，位于安大略省沃恩市，该郊区位于多伦多市中心以北约25公里（16英里）。 塔夫脱广播公司和Great-West人寿保险公司于1981年开业，是加拿大第一个大型主题公园，至今仍是加拿大最大的主题公园。 该公园目前由Cedar Fair拥有，已连续数年成为北美访问量最大的季节性游乐园。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Canada's_Wonderland">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title20">
<h4 className="title">Woodbine Beach</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/7.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Woodbine+Beach/@43.662238,-79.311029,17z/data=!4m8!1m2!2m1!1sWoodbine+Beach!3m4!1s0x89d4cbf1b403037f:0x7e1c4a7ac9e90b29!8m2!3d43.662238!4d-79.3088403">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Woodbine Beach</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9997">Introduction</a>
<div id="modal9997" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Woodbine Beach - Introduction</h4>
    <p> Woodbine Beach is the largest of the four beaches in the Beaches in Toronto, Ontario, Canada. Located along Lake Shore Boulevard at the foot of Woodbine Avenue, it is next to Ashbridge's Bay and Kew-Balmy Beach. Woodbine beach is the westernmost beach in the Beaches, and the series of beaches extend east until the RC Harris Water Treatment Plant. The beach runs parallel to the boardwalk and the Martin Goodman Trail, and is part of Woodbine Beach Park.</p>
    <p className="grey-text">Woodbine海滩是加拿大安大略省多伦多海滩中四个海滩中最大的海滩。 它位于伍德拜恩大道（Woodbine Avenue）脚下的湖岸大道（Lake Shore Boulevard）旁，毗邻阿什布里奇湾（Ashbridge's Bay）和基尤-巴尔米（Kew-Balmy Beach）海滩。 伍德拜恩海滩是海滩中最西端的海滩，一系列海滩向东延伸，直到RC哈里斯水处理厂。 海滩与木板路和马丁·古德曼步道（Martin Goodman Trail）平行，是伍德拜恩海滩公园的一部分。
   </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Woodbine_Beach">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title21">
<h4 className="title" >Toronto Zoo</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/8.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Toronto+Zoo/@43.8177028,-79.1880791,17z/data=!3m1!4b1!4m5!3m4!1s0x89d4d9f1ad96dacd:0x9e197a60028bb5d8!8m2!3d43.817699!4d-79.1858904">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Toronto Zoo</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9998">Introduction</a>
<div id="modal9998" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Toronto Zoo - Introduction</h4>
    <p>The Toronto Zoo is a zoo located in Toronto, Ontario, Canada. Encompassing 287 hectares (710 acres), the Toronto Zoo is the largest zoo in Canada. It is divided into seven zoogeographic regions: Indo-Malaya, Africa, Americas, Tundra Trek, Australasia, Eurasia, and the Canadian Domain. Some animals are displayed indoors in pavilions and outdoors in what would be their naturalistic environments, with viewing at many levels. It also has areas such as the Kids Zoo, Waterside Theatre, and Splash Island. It has one of the most taxonomically diverse collection of animals on display of any zoo; it is currently home to over 5,000 animals (including invertebrates and fish) representing over 500 species. The zoo is open to the public every day of the year except December 25.</p>
    <p className="grey-text">多伦多动物园是位于加拿大安大略省多伦多的动物园。 多伦多动物园占地287公顷（710英亩），是加拿大最大的动物园。 它分为七个动物地理区域：印度马来亚，非洲，美洲，苔原跋涉，大洋洲，欧亚大陆和加拿大领地。 一些动物在自然环境中被展示在室内的凉亭中和室外，并在许多层面上进行观察。 它还有儿童动物园，水边剧院和飞溅岛等地区。 它是任何动物园展出的动物分类学最丰富的动物之一。 目前，这里有超过5,000种动物（包括无脊椎动物和鱼类），它们代表500多种物种。 除12月25日外，该动物园每天都对公众开放。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Toronto_Zoo">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title22">
<h4 className="title">Thousand Islands</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/9.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Thousand+Islands/@44.298924,-76.4270832,10z/data=!3m1!4b1!4m5!3m4!1s0x4ccd4ef10e8e0e1b:0x125cfc305bcff037!8m2!3d44.2987749!4d-76.1468963">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Thousand Islands</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9999">Introduction</a>
<div id="modal9999" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Thousand Islands - Introduction</h4>
    <p> The Thousand Islands are a group of more than 1,800 islands in the St. Lawrence River, straddling the border of the U.S. and Canada. A fashionable retreat for the elite in the late 19th century, today the area is a hub for outdoor activities. It’s home to elaborate island mansions such as the German-style Boldt Castle on Heart Island, and Singer Castle on Dark Island, with its Gothic windows and secret passageways.</p>
    <p className="grey-text">千岛群岛位于圣劳伦斯河上，共有1,800多个岛屿，横跨美国和加拿大的边界。 19世纪后期，这是精英人士的时尚度假胜地，如今，该地区已成为户外活动的枢纽。 这里是精心打造的岛屿豪宅的所在地，例如，心岛上的德国式Boldt城堡和黑岛上的辛格城堡，带有哥特式窗户和秘密通道。
   </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://www.google.com/travel/things-to-do?g2lb=2502548%2C4258168%2C4270442%2C4271060%2C4306835%2C4317915%2C4328159%2C4371335%2C4401769%2C4419364%2C4428792%2C4429191%2C4431296%2C4433754%2C4447566%2C4456077%2C4458304%2C4462650%2C4463263%2C4270859%2C4284970%2C4291517%2C4412690&hl=en-CA&gl=ca&un=1&dest_mid=%2Fm%2F0179bc&dest_state_type=main&dest_src=kl&sa=X&ved=2ahUKEwjL0Y7FqIPtAhVXbs0KHdiaCzoQri4wKXoECCEQAw#ttdm=44.878451_-76.003458_8&ttdmf=%252Fm%252F07l8q8">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}
<div className="titleContent">
    <h5>2018/09/16</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img20/1.png" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Take a boat from Thousand Islands to Castle.</p>
            <p>To get to the island, you need to go through US customs first.</p>
            <p>The return must go through Canadian customs. (When disembarking, the staff just glanced at the passport)</p>
        </div>
    </div>

</div>

</div>

<div className="titles" id="title23">
<h4 className="title">Lake Muskoka</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/10.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Lake+Muskoka/@45.015276,-79.606799,11z/data=!3m1!4b1!4m5!3m4!1s0x4d2a8be67bed8b2b:0xa3ff336db476576a!8m2!3d45.0318626!4d-79.4475238">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Lake Muskoka</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


{/* <a className="btn-flat modal-trigger right info " href="#modal99910">Introduction</a>
<div id="modal99910" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">赏枫 - Introduction</h4>
    <p>奥林匹克体育场是位于加拿大蒙特利尔的多功能体育场，位于城市Hochelaga-Maisonneuve区的奥林匹克公园。它建于1970年代中期，是1976年夏季奥林匹克运动会的主要场馆，因此被昵称为“大O”，既指其名称，又指体育场屋顶永久部件的甜甜圈形状。紧邻体育场的塔楼，蒙特利尔塔，是世界上最高的倾斜塔，仰角为45度。它也被称为“ Big Owe”，是指体育场和整个1976年奥运会的天文成本。
<br/>
<br/>
该体育场是加拿大座位最多的体育场。奥运会之后，安装了人造草皮，它成为蒙特利尔专业棒球队和橄榄球队的所在地。 1998年，CFL的蒙特利尔长者队回到了他们以前的莫尔森体育馆进行常规赛，但是直到2014年他们回到莫尔森体育馆进行所有比赛后，他们都继续使用奥林匹克体育场进行季后赛和灰色杯比赛。</p>
    <p className="grey-text">Olympic Stadium is a multi-purpose stadium in Montreal, Canada, located at Olympic Park in the Hochelaga-Maisonneuve district of the city. Built in the mid-1970s as the main venue for the 1976 Summer Olympics, it is nicknamed "The Big O", a reference to both its name and to the doughnut-shape of the permanent component of the stadium's roof. The tower standing next to the stadium, The Montreal Tower, is the tallest inclined tower in the world with an angle elevation of 45 degrees. It is also called "The Big Owe" to reference the astronomical cost of the stadium and the 1976 Olympics as a whole.
    <br/>
<br/>
The stadium is the largest by seating capacity in Canada. After the Olympics, artificial turf was installed and it became the home of Montreal's professional baseball and football teams. The Montreal Alouettes of the CFL returned to their previous home of Molson Stadium in 1998 for regular season games, but continued to use Olympic Stadium for playoff and Grey Cup games until 2014 when they returned to Molson Stadium for all of their games. </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Olympic_Stadium_(Montreal)">
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div> */}

</div>
    </div>
</div>




</div>

<div className="titles" id="title24">
<h4 className="title">Niagara Falls</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/11.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Niagara+Falls,+ON/@43.054098,-79.2281194,11z/data=!3m1!4b1!4m5!3m4!1s0x89d3445eec824db9:0x46d2c56156bda288!8m2!3d43.0895577!4d-79.0849436">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Niagara Falls</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99911">Introduction</a>
<div id="modal99911" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Niagara Falls - Introduction</h4>
    <p>Niagara Falls is a group of three waterfalls at the southern end of Niagara Gorge, spanning the border between the province of Ontario in Canada and the state of New York in the United States. The largest of the three is Horseshoe Falls, also known as Canadian Falls, which straddles the international border of the two countries. The smaller American Falls and Bridal Veil Falls lie within the United States. Bridal Veil Falls are separated from Horseshoe Falls by Goat Island and from American Falls by Luna Island, with both islands situated in New York.</p>
    <p className="grey-text">尼亚加拉大瀑布是由三个瀑布组成的一组，位于尼亚加拉峡谷的南端，横跨加拿大安大略省和美国纽约州之间的边界。 这三个国家中最大的一个是马蹄瀑布，又称加拿大瀑布，横跨两国的国际边界。 较小的美国瀑布和新娘面纱瀑布位于美国境内。 新娘面纱瀑布与山羊岛的马蹄瀑布和月神岛的美国瀑布分开，两个岛都位于纽约。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Niagara_Falls">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title25">
<h4 className="title">Art Gallery of Ontario</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/12.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Art+Gallery+of+Ontario/@43.6536105,-79.394701,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34c5ed5319bd:0xda277755ede046af!8m2!3d43.6536066!4d-79.3925123">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Art Gallery of Ontario</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99912">Introduction</a>
<div id="modal99912" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Art Gallery of Ontario - Introduction</h4>
    <p>The Art Gallery of Ontario is an art museum in Toronto, Ontario, Canada. The museum is located in the Grange Park neighbourhood of downtown Toronto, on Dundas Street West between McCaul and Beverley streets. The museum's building complex takes up 45,000 square metres (480,000 sq ft) of physical space, making it one of the largest art museums in North America. In addition to exhibition spaces, the museum also houses an artist-in-residence office and studio, dining facilities, event spaces, gift shop, library and archives, theatre and lecture hall, research centre, and a workshop.</p>
    <p className="grey-text">安大略美术馆是加拿大安大略省多伦多市的一家美术馆。 该博物馆位于多伦多市中心的格兰奇公园（Grange Park）附近，在麦考尔（McCaul）和贝弗利（Beverley）街道之间的邓达斯西街（Dundas Street West）上。 博物馆的建筑群占地45,000平方米（480,000平方英尺），是北美最大的艺术博物馆之一。 除了展览空间外，博物馆还设有驻场艺术家办公室和工作室，餐饮设施，活动空间，礼品店，图书馆和档案馆，剧院和演讲厅，研究中心以及车间。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Art_Gallery_of_Ontario">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title26">
<h4 className="title">City Hall</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img19/13.png" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Toronto+City+Hall/@43.6534438,-79.3862788,17z/data=!3m1!4b1!4m5!3m4!1s0x882b34cc66e75af3:0x31c21a86913322e0!8m2!3d43.6534399!4d-79.3840901">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">City Hall</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99913">Introduction</a>
<div id="modal99913" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">City Hall - Introduction</h4>
    <p>The Toronto City Hall, or New City Hall, is the seat of the municipal government of Toronto, Ontario, Canada, and one of the city's most distinctive landmarks. Designed by Finnish architect Viljo Revell (with Heikki Castrén, Bengt Lundsten, and Seppo Valjus) and landscape architect Richard Strong, and engineered by Hannskarl Bandel, the building opened in 1965. It was built to replace Old City Hall, which had housed city offices since 1899. The current city hall, located at Nathan Phillips Square, is the city's fourth and was built to replace its predecessor which the city outgrew shortly after its completion.</p>
    <p className="grey-text">多伦多市政厅或新市政厅是加拿大安大略省多伦多市政府所在地，也是该市最独特的地标之一。 该建筑由芬兰建筑师Viljo Revell（与HeikkiCastrén，Bengt Lundsten和Seppo Valjus共同设计）和景观设计师Richard Strong设计，并由Hannskarl Bandel设计，于1965年开放。它的建成是为了取代旧市政厅，该市政厅设有市政厅。 自1899年以来。当前的市政厅位于内森·菲利普斯广场（Nathan Phillips Square），是该市的第四座市政厅，其建成是为了取代其前身，后者在建成后不久就消失了。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Toronto_City_Hall">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>



    <h4 className="title"> </h4>

    {/* <div className="Comment">
    
        <div className="row">   
        <div className="col s1 m1 l1">
            <a className="btn btn-floating black lighten-1 ">YX</a>
        </div>
        <div className="col s11 m11 l11 commentContent">
            <form action="">
                <div className="input-field">
                    <textarea id="message" className="materialize-textarea"></textarea>
                    <label htmlFor="message">发表评论</label>
                </div>
            </form>
        </div>
        </div>

      

    </div> */}
    


</div>
</div>
  

            
            <footer className="page-footer black darken-3">
                <div className="container">
                <div className="row">

                    <div className="flex text-xs-center col l1 m2 s12">
                        {/* <img salt="" className="responsive-img"></img> */}
                        <p className="center">Y.X.</p>
                    </div>

                    <div className="col l5 offset-l1 m5 s12 hide-on-small-only">
                    <h5>Who is Y.X.?</h5>
                    <p>Y.X. graduated from uOttawa in 2020. She studied computer science and mathematics. She enjoys programming, travelling & playing instruments.</p>
                    </div>
              

                    <div className="col l4 offset-l1 m5 s12">
                    {/* <h5 className="white-text">Connect</h5> */}
                    <div className="text-xs-center mx my social-icons">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" >
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent">
                        <i className="fab fa-youtube"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent">
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent">
                        <i className="fab fa-twitter"></i>
                    </a>
                    </div>
                    </div>
                </div>
                </div>
                <div className="footer-copyright grey darken-4">
                <div className="container copyright center-align">Copyright &copy; 2020 Y.X.</div>
                </div>
            </footer>
  
            </section>
        )
    }
}




export default travelNoteToronto;